<p-toast
  key="toast-prime-component"
  [position]="'top-right'"
  [showTransitionOptions]="'1000ms'"
  [hideTransitionOptions]="'100ms'"
  [showTransformOptions]="'translateX(100%)'"
  [style]="{ maxWidth: '310px' }"
  preventOpenDuplicates>
  <ng-template pTemplate="message" let-message>
    <div
      class="main-container flex items-start gap-spacing-xs w-full"
      [class.cursor-pointer]="!!message.data?.clickCb"
      (mousedown)="message.data?.clickCb()">
      <i
        class="flex align-items-center justify-content-center ph"
        [class.ph-fill]="message.severity === 'success'"
        [class.ph-check-circle]="message.severity === 'success'"
        [class.ph-info]="message.severity === 'info'"
        [class.ph-warning]="message.severity === 'warn'"
        [class.ph-x-circle]="message.severity === 'error'"></i>
      <div class="flex gap-spacing-default flex-column w-full">
        <div class="label-large-bold">
          {{ message.summary }}
        </div>
        <div class="label-large-regular">{{ message.detail }}</div>
        @if (message.data?.linkRoute) {
          <div
            class="toast-link-container mt-2 flex justify-content-end w-full">
            <a
              [class]="{
                'toast-link-success': message.severity === 'success',
                'toast-link-info': message.severity === 'info',
                'toast-link-warn': message.severity === 'warn',
                'toast-link-error': message.severity === 'error',
                'text-link': true,
              }"
              [routerLink]="message.data.linkRoute"
              (click)="closeMessage()">
              {{ message.data.linkText }}
            </a>
          </div>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
